export const COLORS = ['blue', 'cyan', 'green', 'grey', 'red', 'violet'];



// WEBPACK FOOTER //
// ./src/constants/index.js